import { motion } from "framer-motion";

export default function SectionHeading({ eyebrow, title, accent, testid }) {
  return (
    <motion.div
      className="text-center mb-14 px-6"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6 }}
    >
      <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#BFA45D] font-medium mb-3">
        {eyebrow}
      </p>
      <span className="block overflow-hidden">
        <motion.h2
          data-testid={testid}
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight gold-text inline-block"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          {title}
        </motion.h2>
      </span>
      {accent && (
        <p className="font-accent italic text-lg text-[#E2C882]/80 mt-3 max-w-2xl mx-auto">
          {accent}
        </p>
      )}
      <div className="mt-5 h-px w-24 mx-auto bg-gradient-to-r from-transparent via-[#E2B857] to-transparent" />
    </motion.div>
  );
}
